<template>
    <div class="py-3">
        <div class="container">
            <!-- trip profile navbar !-->
            <TravelExpenseReportTabs :linksDisabled=disableLinks :expenseReportID=expenseReportID ref="nav"></TravelExpenseReportTabs>
            <div class="row">
                <div class="col-md-12">
                    <div v-if="!loading && expenseReport.expenseReportStatusTypeId > 1" style="text-align:center; color:red;">Changes will not be saved unless Save button is clicked</div>
                    <h4 style="font-weight:900; margin-bottom:0px;">Trip Profile <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner></h4>
                    <div class="my-1" style="margin-top:0px;">{{expenseReport.expenseReportStatusTypeName}}</div>
                    <div style="font-style: italic;">
                        <div><font-awesome-icon class="icons" :icon="['far','sticky-note']" /> Note - This page must be fully completed before proceeding to other sections.</div>

                        <div> <font-awesome-icon class="icons" icon="exclamation-triangle" /> Warning - Subsequent changes to locations or dates will delete information entered within the Meals sections.</div>
                        <br />
                    </div>
                    <div v-if="!loading" class="">
                        <div class="form-group"> <label>Trip Name</label> <input type="text" class="form-control w-50" placeholder="Enter Trip Name" v-model="expenseReport.trip.tripName" required> </div>

                        <div v-for="(d,index) in expenseReport.trip.destinations" :key="d.domesticLocationId">
                            <label>
                                Destination {{index + 1}} <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.Destination,index)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </label>



                            <!--<div class="form-group">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-secondary active btn-sm">Domestic </label>
                <label class="btn btn-secondary btn-sm" aria-pressed="false">Foreign </label>
            </div>
        </div>-->

                            <b-form-group>
                                <b-form-radio-group v-model="d.domestic" buttons size="sm"
                                                    :options="[{ text: 'Continental US', value:true },{ text: 'Other US', value:'other' },{ text: 'Foreign', value:false }]"></b-form-radio-group>
                            </b-form-group>


                            <div class="form-group w-50" v-if="d.domestic == true">
                                <label>Work / Event Site Zip</label>
                                <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Please enter the zip code where the work was performed or meeting / conference occurred. Do not enter the zip code of the hotel if that does not correspond to the work/event site.'" icon="info-circle" />
                                <br />
                                <v-select @input="(eventsite) => updateLocations(d, eventsite)" :value="d.eventsite" @search="onSearchZip" :filterable="false" label="city" :clearable="true" :options="zipCodes">
                                    <template slot="no-options">
                                        Enter zip to search city location...
                                    </template>
                                </v-select>
                            </div>

                            <div class="form-group w-50" v-if="d.domestic == 'other'">
                                <label>Work/Event Site location</label>
                                <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Enter Alaska, Hawaii, or Territory name then select applicable City of the event site.'" icon="info-circle" />
                                <v-select @input="(eventsiteOtherDomestic) => updateLocationsOther(d, eventsiteOtherDomestic)" :value="d.eventsiteOtherDomestic" @search="onOtherCity" :filterable="false" :options="USTerritories" label="city" :clearable="true">
                                    <template slot="no-options">
                                        Enter city to search city country location...
                                    </template>
                                    <template v-slot:option="option">
                                        {{ option.city }}, {{option.country}}
                                    </template>
                                </v-select>
                            </div>

                            <div class="form-group w-50" v-if="d.domestic == false">
                                <label>Enter Foreign City Event Site</label>
                                <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Enter Country then select applicable City of the event site.'" icon="info-circle" />
                                <v-select @input="(eventsiteForeign) => updateLocationsForeign(d, eventsiteForeign)" :value="d.eventsiteForeign" @search="onSearchForeignCity" :filterable="false" :options="foreignCountries" label="city" :clearable="true">
                                    <template slot="no-options">
                                        Enter city to search city country location...
                                    </template>
                                    <template v-slot:option="option">
                                        {{ option.city }}, {{option.country}}
                                    </template>
                                </v-select>
                            </div>



                            <div class="form-group"> <label>Purpose</label> <input type="text" class="form-control w-50" placeholder="Enter purpose" v-model="d.purpose"> </div>
                            <div v-if="changeDateWarning" style="color:red;"><font-awesome-icon class="icons" icon="exclamation-triangle" /> Warning - Changes to trip profile will delete information entered within the Meals sections. </div>

                            <div class="row" style="margin-bottom:15px;">
                                <div class="col"> <label>Start Date</label><datepicker :typeable="false" :format="customFormatter" input-class="form-control" :use-utc=true @opened="onDatePickerOpened()" v-model="d.startDate"></datepicker> </div>
                                <div class="col"> <label>End Date</label><datepicker :typeable="false" :format="customFormatter" input-class="form-control" :use-utc=true @opened="onDatePickerOpened()" v-model="d.endDate"></datepicker> </div>
                            </div>


                            <b-form-group>
                                <label>Was there a personal component? <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Submitting for lodging/meal expenses on personal days will require additional explanation.'" icon="info-circle" /></label>
                                <b-form-radio-group v-model="d.personal"
                                                    :options="[{ text: 'Yes', value:true },{ text: 'No', value:false }]"></b-form-radio-group>
                            </b-form-group>


                            <!-- commenting out only used for range not using for demo -->
                            <!-- <div class="form-group"> <label>Start Date</label> <input type="date" class="form-control w-25" required="required"> <small class="form-text text-muted">Sample hint text here</small> </div>
        <div class="form-group"> <label>End Date</label> <input type="date" class="form-control w-25" required="required"> <small class="form-text text-muted">Sample hint text here</small> </div> -->
                            <div v-if="changeDateWarning" style="color:red;"><font-awesome-icon class="icons" icon="exclamation-triangle" /> Warning - Changes to trip profile will delete information entered within the Meals sections. </div>
                            <div v-for="(p,pDIndex) in d.personalDates" class="form-group" v-if="d.personal">


                                <!--<div class="form-group" v-if="d.personal">
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="btn btn-secondary active btn-sm">
                        <input type="radio" name="options" id="option1" autocomplete="off" checked=""> Individual
                    </label>
                    <label class="btn btn-secondary btn-sm">
                        <input type="radio" name="options" id="option2" autocomplete="off"> Range
                    </label>
                </div>
            </div>-->

                                <b-form-group v-if="d.personal">
                                    <b-form-radio-group size="sm" :id="'personal-button-radio' + pDIndex"
                                                        v-model="p.personalRange"
                                                        :options="[{ text: 'Individual', value: true },{ text: 'Range', value: false }]"
                                                        buttons
                                                        :name="'personal-button-radio' + pDIndex">
                                    </b-form-radio-group>
                                </b-form-group>

                                <label>
                                    Personal Date {{pDIndex + 1}} <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.PersonalDay,index,pDIndex)">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </label>
                                <div class="row">
                                    <div v-if="p.personalRange == true" class="col">

                                        <datepicker :typeable="false" :format="customFormatter" input-class="form-control w-50" :use-utc=true v-model="p.startDate" @input="onDateChanged" @opened="onDatePickerOpened()"></datepicker>
                                    </div>
                                    <div v-if="p.personalRange == false" class="col">
                                        <label>From</label>
                                        <datepicker :typeable="false" :format="customFormatter" input-class="form-control" :use-utc=true v-model="p.startDate" @opened="onDatePickerOpened()" @input="onDateChanged"></datepicker>
                                    </div>
                                    <div v-if="p.personalRange == false" class="col">
                                        <label>To</label>
                                        <datepicker :typeable="false" :format="customFormatter" input-class="form-control" :use-utc=true v-model="p.endDate" @opened="onDatePickerOpened()" @input="onDateChanged"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <!-- Increment Personal Day -->
                            <div class="form-group" v-if="d.personal">
                                <a class="btn btn-secondary btn-sm btn-text-white" @click="addPersonalDay(index)">Add Personal Date </a>
                            </div>

                            <!-- new end -->

                        </div>
                        <!-- Show if not already shown -->
                        <div class="form-group" style="padding-top:25px;">
                            <a class="btn btn-secondary btn-sm btn-text-white" @click="addDestination">Add Destination</a>
                            <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Lodging and meal per diems for this destination begin with the start date.'" icon="info-circle" />
                        </div>

                        <b-form-group label="Did you fly to / from another airport as a consequence of personal travel?">
                            <b-form-radio-group v-model="expenseReport.trip.additionalAirport"
                                                :options="[{ text: 'Yes', value:true },{ text: 'No', value:false }]"></b-form-radio-group>
                        </b-form-group>

                        <b-form-textarea id="supportingRemark"
                                         v-model="expenseReport.trip.supportingRemark"
                                         placeholder="Supporting remarks, if needed"
                                         rows="1"
                                         max-rows="3"
                                         style="margin-bottom:15px;">
                        </b-form-textarea>

                        <button @click="onSave" class="btn btn-primary btn-lg">Save</button>
                    </div>
                </div>
                <CommentsComponent v-if="!loading && expenseReport.expenseReportStatusTypeId > 1" :expenseReportID="expenseReportID" :area="'trip'"></CommentsComponent>
                <div class="col-md-12" v-if="!loading && expenseReport.expenseReportStatusTypeId > 1">
                    <!-- audit history comp -->
                    <AuditHistoryComponent :expenseReportID="expenseReportID" :area="'trip'"></AuditHistoryComponent>
                </div>
            </div>
        </div>
        <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
            <div class="modal-body">
                Are you sure you want to remove this item?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
                <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
            </div>
        </modal>
        <modal title="Save progress?" :is-small="true" v-if="show_modal" @close="show_modal = false">
            <div class="modal-body">
                Save changes to expense report?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="saveAndContinue(true)">Save</button>
                <button type="button" class="btn btn-primary" @click="saveAndContinue(false)">Cancel</button>
            </div>
        </modal>
    </div>
</template>

<style scoped>
    .btn-text-white {
        color: white !important
    }
</style>

<script>
    // @ is an alias to /src
    import Datepicker from 'vuejs-datepicker';
    import TripProfileService from '@/services/TripProfileService'
    import TravelExpenseReportTabs from '@/components/TravelExpenseReportTabs.vue'
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import modal from '@/components/modal.vue'
    import moment from 'moment'

    export default {
        name: 'travel-expense-report',
        components: {
            AuditHistoryComponent,
            CommentsComponent,
            TravelExpenseReportTabs,
            Datepicker,
            modal
        },
        async created() {
            //monkey patch datepicker library to support opened event properly.
            //https://github.com/charliekassel/vuejs-datepicker/issues/777
            Datepicker.methods.showCalendar = function () {
                if (this.disabled || this.isInline) {
                    return false;
                }
                if (this.isOpen) {
                    return this.close(true);
                } else if (!this.isInline) {
                    this.$emit('opened');
                }
                this.setInitialView();
            };


            //check if existing report
            if (this.$route.params.erid) {
                this.loading = true;
                this.expenseReportID = this.$route.params.erid;
                this.expenseReport = await TripProfileService.getExpenseReport(this.expenseReportID);
                
                let domesticLocations = await TripProfileService.getDomesticLocations();
                this.mapDomesticInformationToDestination(domesticLocations);

                let foreignLocations = await TripProfileService.getForeignLocations();
                this.mapForeignInformationToDestination(foreignLocations);

                let usOtherLocations = await TripProfileService.getUSTerritoryLocations();
                this.mapUSTerritoryInformationToDestination(usOtherLocations);

                this.loading = false;
                this.disableLinks = false;

                // create a hash so we can detect changes
                this.hash = this.hashData;
            }
            //its new, seed a desitnation object
            else {
                this.expenseReport = {
                    expenseReportStatusTypeId: null,
                    expenseReportStatusTypeName: null,
                    id: null,
                    trip: {
                        destinations: [
                            {
                                domestic: true,
                                foreign: false,
                                eventsite: null,
                                eventsiteOtherDomestic: null,
                                eventsiteForeign: null,
                                purpose: null,
                                startDate: null,
                                endDate: null,
                                personal: false,
                                personalDates: []
                            }],
                        additionalAirport: false,
                        expenseReportId: null,
                        hasForeignDestination: null,
                        id: null,
                        supportingRemark: null,
                        tripName: null
                    }
                }
            }
        },
        data: function () {
            return {
                changeDateWarning: false,
                expenseReportStatusTypeId: 1,
                loading: false,
                disableLinks: true,
                expenseReportID: null,
                expenseReport: null,
                sitezip: "",
                zipCodes: [],
                foreignCountryLocations: [],
                USTerrirtoryLocations: [],
                allZipCodes: [],
                destitnations: [],
                foreignCountries: [],
                USTerritories: [],
                show_modal: false,
                navNext: null,
                show_modal_remove: false,
                ItemRemoveType: {
                    PersonalDay: 0,
                    Destination: 1,
                    RentalAdditionalAmount: 2,
                    FuelCost: 3,
                    FuelCostAttachment: 4,

                }
            }
        },
        computed: {
            isPersonalComponentToTrip: function () {
                //itterate across all desitnations to see if there is a personal property = true, if so return true otherwise false
                return _.filter(this.expenseReport.trip.destinations, d => d["personal"]).length > 0;
            },
            hashData: function () {
                console.log('Hashing data');
                console.log(this.expenseReport);
                return JSON.stringify(TripProfileService.createSaveRequest(this.expenseReport));
            }
        },
        methods: {
            updateLocations(d, eventsite) {
                d.eventsite = eventsite;
                this.$forceUpdate();
            },
            updateLocationsOther(d, eventsiteOtherDomestic) {
                d.eventsiteOtherDomestic = eventsiteOtherDomestic;
                this.$forceUpdate();
            },
            updateLocationsForeign(d, eventsiteForeign) {
                d.eventsiteForeign = eventsiteForeign;
                this.$forceUpdate();
            },
            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.removePersonalDay(index);
                        break;
                    case 1:
                        this.removeDestination(index);
                        break;
                    case 2:
                        this.removeAdditionalAmountAttachment(index, attachIndex);
                        break;
                    case 3:
                        this.removeFuelCost(index);
                        break;
                    case 4:
                        this.removeFuelCostAttachment(index, attachIndex);
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            customFormatter(date) {
                const dateOutput = moment.utc(date).format('MMM DD YYYY');
                console.log(dateOutput);
                return dateOutput;
            },
            onDateChanged(changedDate) {
                console.log(changedDate)
            },
            onDatePickerOpened() {
                console.log('opened')
                if (this.expenseReportID) {
                    this.changeDateWarning = true;
                }
            },
            mapForeignInformationToDestination: function (foreignLocations) {
                //get list of domestic destination ids to filter with
                let dIDs = this.expenseReport.trip.destinations.map((d) => {
                    return d.foreignLocationId;
                })

                //set foreignCountryLocations options to only the ones we need. No need to spam 6mbs worth of options
                this.foreignCountryLocations = _(foreignLocations)
                    .keyBy('id')
                    .at(dIDs)
                    .filter()
                    .value();

                let me = this;
                //map foreignCountryLocations object to selected v-model
                _.map(this.expenseReport.trip.destinations, (d) => {
                    let result = _.find(this.foreignCountryLocations, { id: d.foreignLocationId });
                    me.$set(d, 'eventsiteForeign', result)
                });
            },
            mapUSTerritoryInformationToDestination: function (otherLocations) {
                //get list of domestic destination ids to filter with
                let dIDs = this.expenseReport.trip.destinations.map((d) => {
                    return d.otherDomesticLocationId;
                })
                console.log(dIDs)
                //set foreignCountryLocations options to only the ones we need. No need to spam 6mbs worth of options
                this.USTerrirtoryLocations = _(otherLocations)
                    .keyBy('id')
                    .at(dIDs)
                    .filter()
                    .value();

                console.log('territories')
                console.log(this.USTerrirtoryLocations)

                let me = this;
                //map foreignCountryLocations object to selected v-model
                _.map(this.expenseReport.trip.destinations, (d) => {
                    let result = _.find(this.USTerrirtoryLocations, { id: d.otherDomesticLocationId });
                    me.$set(d, 'eventsiteOtherDomestic', result)
                });
            },
            mapDomesticInformationToDestination: function (domesticLocations) {
                //get list of domestic destination ids to filter with
                let dIDs = this.expenseReport.trip.destinations.map((d) => {
                    return d.domesticLocationId;
                })

                //set zipCode options to only the ones we need. No need to spam 6mbs worth of options
                this.zipCodes = _(domesticLocations)
                    .keyBy('id')
                    .at(dIDs)
                    .filter()
                    .value();

                //map zipcode object to selected v-model
                _.map(this.expenseReport.trip.destinations, (d) => {
                    d.eventsite = _.find(this.zipCodes, { id: d.domesticLocationId });
                });
            },
            onSearchZip: function (zip, loading) {
                if (zip) {
                    loading(true);
                    this.getCityStateByZip(zip, loading, this);
                }
            },
            onOtherCity: function (query, loading) {
                if (query) {
                    loading(true);
                    this.getOtherCity(query, loading, this);
                }
            },
            getOtherCity: _.debounce(async (query, loading, vm) => {
                let response = await TripProfileService.getUSTerritoriesByCityOrCountry(query);
                vm.USTerritories = response;
                loading(false)
            }, 800),
            onSearchForeignCity: function (query, loading) {
                if (query) {
                    loading(true);
                    this.getForeigncityCountryByCity(query, loading, this);
                }
            },
            getForeigncityCountryByCity: _.debounce(async (query, loading, vm) => {
                let response = await TripProfileService.getForeignLocationsByCityOrCountry(query);
                vm.foreignCountries = response;
                loading(false)
            }, 800),
            getCityStateByZip: _.debounce(async (zip, loading, vm) => {
                let response = await TripProfileService.getDomesticLocationsByZip(zip);
                vm.zipCodes = response;
                loading(false);
            }, 800),
            addDestination: function () {
                this.expenseReport.trip.destinations.push({
                    domestic: true,
                    foreign: false,
                    eventsite: null,
                    eventsiteOtherDomestic: null,
                    eventsiteForeign: null,
                    purpose: null,
                    startDate: null,
                    endDate: null,
                    personal: false,
                    additionalAirport: false,
                    personalDates: []
                })
            },
            addPersonalDay: function (index) {
                this.expenseReport.trip.destinations[index].personalDates.push(
                    {
                        startDate: null,
                        endDate: null,
                        additionalAirport: false,
                        personalRange: true
                    })
            },
            removePersonalDay: function (index, pDIndex) {
                this.expenseReport.trip.destinations[index].personalDates.splice(pDIndex, 1);
            },
            removeDestination(index) {
                this.expenseReport.trip.destinations.splice(index, 1);
            },
            async saveAndContinue(save) {
                let success = false;
                if (save) {
                    success = await this.onSave();
                    if (success) {
                        this.navNext();
                    } else {
                        this.navNext(false);
                    }
                }
                else {
                    this.navNext();
                    this.show_modal = false;
                }
            },
            async onSave() {
                console.log('TripProfile.Methods.onSave')
                let isSuccess = false;
              
                //validation
                let validationErrors = TripProfileService.validateExpenseReport(this.expenseReport);
                console.log(validationErrors)

                if (!_.isEmpty(validationErrors)) {
                    return this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        duration: 3500,
                        text: validationErrors.join("<br>")
                    });
                }

                let onSaveRequest = TripProfileService.createSaveRequest(this.expenseReport);


                //update
                if (this.expenseReportID) {
                    onSaveRequest.id = this.expenseReportID;
                    onSaveRequest.Trip.expenseReportId = this.expenseReportID;
                    onSaveRequest.Trip.id = this.expenseReport.trip.id;
                    onSaveRequest.Trip.additionalAirport = this.expenseReport.trip.additionalAirport;

                    try {
                        let response = await TripProfileService.saveExpenseReport(onSaveRequest);
                        this.disableLinks = false;
                        this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Trip saved successfully" });
                        this.$router.push({ path: "/travel-expense-report/" + response.trip.expenseReportId });
                        isSuccess = true;
                        window.scrollTo(0, 0);
                    } catch (e) {
                        console.log('ERRRRORRR')
                        console.log(e.response)
                        let guiError = e;
                        if (e.data) { guiError = e.data.join("<br>") }
                        this.$notify({ group: 'errors', type: 'error', title: 'Error', text: guiError });
                    }
                    finally {
                        this.$refs.nav.getSummaryCosts();
                        this.loading = false
                    }
                }
                else {
                    //create new
                    try {
                        onSaveRequest.Trip.additionalAirport = this.expenseReport.trip.additionalAirport;
                        let response = await TripProfileService.saveExpenseReport(onSaveRequest);
                        this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Trip saved successfully" });
                        this.disableLinks = false;

                        this.expenseReportID = response.trip.expenseReportId;
                        this.expenseReport = await TripProfileService.getExpenseReport(response.trip.expenseReportId);

                        let domesticLocations = await TripProfileService.getDomesticLocations();
                        this.mapDomesticInformationToDestination(domesticLocations);

                        let foreignLocations = await TripProfileService.getForeignLocations();
                        this.mapForeignInformationToDestination(foreignLocations);

                        let usOtherLocations = await TripProfileService.getUSTerritoryLocations();
                        this.mapUSTerritoryInformationToDestination(usOtherLocations);


                        this.$router.push({ path: "/travel-expense-report/" + response.trip.expenseReportId });
                        isSuccess = true;
                        window.scrollTo(0, 0);
                    } catch (e) {
                        console.log('ERRRRORRR')
                        console.log(e.response)
                        let guiError = e;
                        if (e.data) { guiError = e.data.join("<br>") }
                        this.$notify({ group: 'errors', type: 'error', title: 'Error', text: guiError });
                    }
                    finally {
                        this.$refs.nav.getSummaryCosts();
                        this.loading = false
                    }
                }
                this.hash = this.hashData;
                return isSuccess;
            }
        },
        //auto save when navigating away from section
        async beforeRouteLeave(to, from, next) {
            if (this.expenseReport.expenseReportStatusTypeId > 1) {
                next()
            }
            else {
                this.navNext = next;

                if (this.hash !== this.hashData) {
                    this.show_modal = true;
                }
                else {
                    console.log("Data has not changed");
                    next();
                }
            }
        }
    }

</script>

